<template>
  <div class="footer">
    <div class="footer-container">
      <el-row :gutter="30" type="flex" justify="space-between">
        <el-col :span="6" :offset="0">
          <div class="column-title">关于瑞波琴</div>
          <div class="column-item">
            <a href="/about/lydia-sarfati">品牌创始人</a>
          </div>
          <div class="column-item">
            <a href="/about/seaweed">海藻科学</a>
          </div>
        </el-col>
        <el-col :span="6" :offset="0">
          <div class="column-title">产品系列</div>
          <div class="column-item"><a href="/products/hydraBlue">HYDRA BLUE® 臻蓝水漾系列</a></div>
          <div class="column-item"><a href="/products/hydraMedic">HYDRA MEDIC®净透控油系列</a></div>
          <div class="column-item"><a href="/products/hydraDewPure">HYDRA DEW PURE™赋活修复系列</a></div>
          <div class="column-item"><a href="/products/hydra4">HYDRA 4®舒缓焕活系列</a></div>
        </el-col>
        <el-col :span="6" :offset="0">
          <div class="column-title">客户支持</div>
          <div class="column-item"><a href="/anti_fake">防伪查询</a></div>
          <div class="column-item"><a href="/pictures">图片查询</a></div>
          <div class="column-item"><a href="https://v.qq.com/s/videoplus/2642060426" target="_blank">操作视频</a></div>
          <div class="column-item">客户服务热线</div>
          <div class="column-item"><i class="el-icon-phone-outline"></i> 028-86530702</div>
        </el-col>
        <el-col :span="6" :offset="0">
          <img class="repechage-logo-footer" src="@/assets/repechage-logo-black.png" alt="repechage">
          <div class="sns">
            <div class="social-icons">
              <a href="https://mp.weixin.qq.com/s/q5Vqq_ux4Bcr1DIffaxtqA" target="_blank"><img class="wechat-icon" src="@/assets/images/social/wechat_black.png" alt="微信公众号"></a>
              <a href="https://weibo.com/p/1006067371870623" target="_blank"><img class="weibo-icon" src="@/assets/images/social/weibo_black.png" alt="微博"></a>
              <a href="https://www.xiaohongshu.com/user/profile/5de07ced000000000100aab7" target="_blank"><img class="red-icon" src="@/assets/images/social/red_black.png" alt="小红书"></a>
            </div>
          </div>
          <div class="wechat-title">Repêchage® 官方微信公众号</div>
          <div class="wxqr-wrap">
            <img class="wxqr" src="@/assets/images/wxqr.png" alt="瑞波琴微信公众号">
          </div>
        </el-col>
      </el-row>
      <div>
        <span class="copy-right">©威格罗（成都）生物科技有限公司版权所有</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">蜀ICP备2023005229号</a>
        <img src="/gov/gov.png" class="gov-img">
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010502011781" target="_blank" class="beian">川公网安备 51010502011781号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
a{
  text-decoration: none;
  color: #25282a;
}
.footer{
  width: 100%;
  background-color: #b1e4e3;
  color: #25282a;
  font-size: 14px;
  box-sizing: border-box;
  padding: 50px 15px;
}
.footer-container{
  max-width: 1200px;
  margin: 0 auto;
}
.column{
  flex: 1;
  box-sizing: border-box;
  padding: 0 20px;
}
.column-title{
  font-size: 17px;
  font-weight: 600;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.repechage-logo-footer{
  width: 60%;
}
.social-icons{
  padding-left: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.red-icon{
  max-height: 50px;
}
.wechat-icon{
  max-width: 25px;
  margin-right: 20px;
}
.weibo-icon{
  max-width: 25px;
  margin-right: 20px;
}
.wechat-title{
  font-size: 14px;
  padding-left: 10px;
  margin-bottom: 15px;
}
.wxqr-wrap{
  box-sizing: border-box;
  padding-left: 10px;
}
.wxqr{
  width: 35%;
}
.column-item{
  margin-bottom: 15px;
}
.copy-right{
  font-size: 12px;
  color: #606266;
}
.beian{
  font-size: 12px;
  padding: 0 10px;
}
.gov-img{
  height: 20px;
  width: 20px;
}
.beian{
  color: #606266;
}
</style>
